import React, { useEffect, useState } from 'react';
import { Label, Input } from 'reactstrap';
import '../../assets/style/TaskAssign.css';
import { Button, Col, Row } from 'react-bootstrap';
import MSelect from '../../components/MSelect';
import MTextField from '../../components/MTextField';
import {
  CLICK_ACTIONS,
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  TASK_ACTION,
} from '../../utils/Constant';
import SearchIcon from '@mui/icons-material/Search';
import {
  ColXsMdType,
  MapOptionType,
  MUILocationFilterType,
  SelectOptionType,
} from '../../utils/Types';
import moment from 'moment';
import { leadSelector } from '../../features/leadSlice';
import MUILocationFilter from '../../components/MUILocationFilter';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { VIEW_LEADOTHERDETAILS_HEADER } from './LeadPageHelper';
import KTable from '../../components/KTable';
import {
  Autocomplete,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import {
  getPincodeDropData,
  locationFilterSelector,
} from '../../features/locationFilterSlice';
import DatePicker from '../../components/KDatePicker';

const blankLocationOther = {
  sl: '',
  pincode: '',
  location: '',
  district: '',
  state: null,
  city: '',
  statecode: '',
  statecd: '',
  pincodecol: '',
  did: '',
  zone: '',
  zones: '',
};
interface ICreateTaskOtherPageProps {
  leadStatus?: any;
  disabled?: any;
  leadOtherDetails?: any;
  leadOtherList?: any;
  setLeadOtherDetails: (data: any) => void;
  setLeadOtherList: (data: any) => void;
  selectedLeadTypeId: any;
  defaultLocationOptions: any;
  zoneName: any;
  stateName: any;
  districtName: any;
  villageName: any;
  locationData: any;
  inputValue: any;
  searchTerm: any;
  ifPincode: any;
  pincodeData: any;
  selectedPincodeData: any;
  setZoneName: (data: any) => void;
  setStateName: (data: any) => void;
  setDistrictName: (data: any) => void;
  setVillageName: (data: any) => void;
  setLocationData: (data: any) => void;
  setInputValue: (data: any) => void;
  setSearchTerm: (data: any) => void;
  setIfPincode: (data: any) => void;
  setPincodeData: (data: any) => void;
  setSelectedPincodeData: (data: any) => void;
  validateOtherLead: () => Promise<boolean>;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const OtherSectionPage: React.FunctionComponent<ICreateTaskOtherPageProps> = ({
  leadStatus,
  disabled,
  leadOtherDetails,
  leadOtherList,
  setLeadOtherDetails,
  setLeadOtherList,
  selectedLeadTypeId,
  defaultLocationOptions,
  zoneName,
  stateName,
  districtName,
  villageName,
  locationData,
  inputValue,
  searchTerm,
  ifPincode,
  pincodeData,
  selectedPincodeData,
  setZoneName,
  setStateName,
  setDistrictName,
  setVillageName,
  setLocationData,
  setInputValue,
  setSearchTerm,
  setIfPincode,
  setPincodeData,
  setSelectedPincodeData,
  validateOtherLead,
}: ICreateTaskOtherPageProps) => {
  const leadTypeInterestedIn: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeInterestedIn;
  const [leadTypeInterestedInDropOptions, setLeadTypeInterestedInDropOptions] =
    useState<SelectOptionType[]>([]);

  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;
  const districtData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).districtData;
  const zoneOption =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...zoneOptionRaw]
      : zoneOptionRaw;

  const dispatch = useAppDispatch();

  useEffect(() => {
    setLeadTypeInterestedInDropOptions(leadTypeInterestedIn);
  }, [leadTypeInterestedIn]);

  const handleAddOtherLead = async () => {
    const isValid = await validateOtherLead();

    if (!isValid) {
      return;
    }

    console.log('locationData', locationData);

    setLeadOtherList((prev: any) => [
      ...prev,
      {
        id: Date.now(),
        ...leadOtherDetails,
        date: leadOtherDetails?.date
          ? moment(leadOtherDetails.date).format('YYYY-MM-DD')
          : '',
        timeframeOfPurchase: moment(
          leadOtherDetails?.timeframeOfPurchase
        ).format('YYYY-MM-DD'),
        state: Number(locationData.state),
        district: Number(locationData.district),
        city: Number(locationData.city),
        zone: Number(locationData.zone),
        pincode: locationData.pincode,
        zoneName,
        stateName,
        districtName,
        villageName,
        remove: 'Remove',
      },
    ]);
    console.log('villageName', villageName);
    // Clear inputs after adding
    setLeadOtherDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      interestedFor: '',
      AadharNumber: '',
      date: '',
      timeframeOfPurchase: '',
      everInsured: '',
      additionalInformation: '',
      intrestedForName: '',
    });
    setLocationData(blankLocationOther);
    setInputValue('');
    setPincodeData([]);
    setSearchTerm(false);
    setSelectedPincodeData({
      label: '',
      value: '',
    });
  };
  const handleRemoveOtherLead = (id: number) => {
    setLeadOtherList((prev: any) => prev.filter((item: any) => item.id !== id));
  };

  const handleSearchClick = async () => {
    if (inputValue?.length == 6) {
      await dispatch(getPincodeDropData(inputValue)).then((res) => {
        console.log('res-487', res);
        if (res?.payload?.status === 'SUCCESS') {
          if (res?.payload?.data?.length > 0) {
            const data =
              res?.payload?.data[0]?.map((item: any) => ({
                ...item,
                pincode: item?.pincodeId,
                mandal: item.mandalName,
                label:
                  item.mandalName +
                  ' - ' +
                  item.villageName +
                  ' - ' +
                  item.pincodeId,
                value: item?.pincodeId,
                id: item?.pincodeId,
              })) || [];
            setIfPincode(true);
            // setSelectedPincodeData(null);
            setPincodeData(data);
          }
        }
        if (res?.payload?.status === 'FAILED') {
          setPincodeData([]);
          setIfPincode(false);
        }
      });
    } else {
      setPincodeData([]);
      setIfPincode(false);
    }
  };

  return (
    <div className="inner-div">
      <Row className="align-items-center mb-3">
        <Col xs={6}>
          <Label className="header-style mb-0">Lead Details</Label>
        </Col>

        {leadStatus == TASK_ACTION.CREATE && (
          <Col xs={6} className="text-end">
            <Button
              variant="primary"
              onClick={handleAddOtherLead}
              disabled={disabled}
            >
              Add Lead
            </Button>
          </Col>
        )}
      </Row>
      <Row className="mt-1">
        <Col xs={12} md={4}>
          <MTextField
            label="Lead First Name"
            required
            value={leadOtherDetails?.firstname ?? ''}
            onChange={(e) => {
              const inputValue = e.target.value;
              setLeadOtherDetails({
                ...leadOtherDetails,
                firstname: inputValue,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4}>
          <MTextField
            label="Lead Last Name"
            required={true}
            value={leadOtherDetails?.lastname ?? ''}
            onChange={(e) => {
              const inputValue = e.target.value;
              setLeadOtherDetails({
                ...leadOtherDetails,
                lastname: inputValue,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin">
          <MTextField
            label="Contact Number"
            required
            value={leadOtherDetails?.contactNumber}
            onChange={(data) => {
              if (data.target.value.length <= 10) {
                setLeadOtherDetails({
                  ...leadOtherDetails,
                  contactNumber: data.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <MTextField
            label="Alternate Contact Number"
            required={false}
            value={leadOtherDetails?.alternateContactNumber}
            onChange={(data) => {
              if (data.target.value.length <= 10) {
                setLeadOtherDetails({
                  ...leadOtherDetails,
                  alternateContactNumber: data.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={12} md={5}>
          {leadStatus == TASK_ACTION.CREATE ? (
            <Autocomplete
              open={ifPincode}
              onOpen={() => setIfPincode(true)}
              onClose={() => setIfPincode(false)}
              options={pincodeData}
              getOptionLabel={(option) => String(option?.label)}
              value={selectedPincodeData ?? null}
              inputValue={inputValue}
              onInputChange={(event, newValue, reason) => {
                if (reason !== 'reset') {
                  const safeValue =
                    typeof newValue === 'string' ? newValue : '';
                  console.log('safeValue', safeValue);
                  setInputValue(safeValue);
                }
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={async (event, newValue) => {
                console.log('newValue', newValue);
                if (newValue) {
                  const validZoneIds =
                    (await zoneOption.map((zone) => zone.value)) || [];
                  const validStateIds =
                    (await Object.values(allStates).flatMap((group) =>
                      group.map((item) => item.value)
                    )) || [];
                  const districtsLength =
                    (await Object.keys(districtData).length) ?? 0;
                  if (
                    !validZoneIds.includes(String(newValue.zoneId)) ||
                    !validStateIds.includes(String(newValue.stateId)) ||
                    districtsLength == 0
                  ) {
                    alert('This location isn’t within your assigned region');
                    setInputValue('');
                    setPincodeData([]);
                    setLocationData(blankLocationOther);
                    return;
                  }
                  setSearchTerm(true);
                  setSelectedPincodeData(newValue);
                  setLocationData({
                    ...locationData,
                    zone: newValue.zoneId,
                    state: newValue.stateId,
                    district: newValue.districtId,
                    city: newValue.villageId,
                    pincode: newValue.pincode,
                  });
                  setZoneName(newValue.zoneName);
                  setStateName(newValue.stateName);
                  setDistrictName(newValue.districtName);
                  setVillageName(
                    newValue.mandalName
                      ? newValue.mandalName + '-' + newValue.villageName
                      : newValue.villageName
                  );
                } else {
                  setInputValue('');
                  setPincodeData([]);
                  setLocationData(blankLocationOther);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pincode"
                  InputLabelProps={{
                    style: { fontSize: '0.8rem' },
                  }}
                  error={
                    inputValue !== '' &&
                    (!/^\d{6}$/.test(inputValue) ||
                      Number(inputValue) < 100001 ||
                      Number(inputValue) > 999999)
                  }
                  helperText={
                    inputValue !== '' &&
                    (!/^\d{6}$/.test(inputValue) ||
                      Number(inputValue) < 100001 ||
                      Number(inputValue) > 999999)
                      ? 'Enter a valid 6-digit pincode between 100001 and 999999'
                      : ''
                  }
                  variant="outlined"
                  id="searchPincode"
                  required
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        <InputAdornment position="end">
                          <IconButton onClick={handleSearchClick}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      </>
                    ),
                  }}
                />
              )}
              disabled={false}
            />
          ) : (
            <MTextField
              label="Pincode"
              required
              value={locationData.pincode ?? ''}
              numberOnly
              disabled
            />
          )}
        </Col>
      </Row>
      <div className="mt-3">
        <MUILocationFilter
          size={{
            zone: colSize,
            state: colSize,
            district: colSize,
            city: colSize,
          }}
          filterData={{
            zone: locationData.zone,
            state: locationData.state,
            district: locationData.district,
            city: locationData.city,
          }}
          setLocationFilter={(filter: MUILocationFilterType) => {
            setLocationData({
              ...locationData,
              zone: filter.zone,
              state: filter.state,
              district: filter.district,
              city: filter.city,
              pincode: filter.pincode ?? '',
            });
          }}
          disabled={disabled}
          required={true}
          defaultLocationOptions={defaultLocationOptions}
          selectedLeadTypeId={selectedLeadTypeId}
          setZoneName={(data) => setZoneName(data)}
          setStateName={(data) => setStateName(data)}
          setDistrictName={(data) => setDistrictName(data)}
          setVillageName={(data) => setVillageName(data)}
          setInputValue={(data: any) => {
            setInputValue(String(data));
          }}
          searchTerm={searchTerm}
          setSearchTerm={(data: any) => {
            setSearchTerm(data);
          }}
        />
      </div>
      <Row>
        <Col xs={12} md={4} className="col-margin mt-3">
          <MSelect
            label="Interested In"
            required
            disabled={disabled}
            options={leadTypeInterestedInDropOptions}
            value={leadOtherDetails?.interestedFor ?? ''}
            onChange={async (e) => {
              const selectedOthers =
                await leadTypeInterestedInDropOptions?.find(
                  (option: any) =>
                    Number(option.value) === Number(e.target.value)
                );
              setLeadOtherDetails({
                ...leadOtherDetails,
                interestedFor: Number(e.target.value),
                intrestedForName: selectedOthers?.label || '',
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <MTextField
            label="Aadhar number"
            required={false}
            value={leadOtherDetails?.AadharNumber}
            onChange={(e) => {
              if (e.target.value.length <= 12) {
                setLeadOtherDetails({
                  ...leadOtherDetails,
                  AadharNumber: e.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin">
          <DatePicker
            label="Date of birth"
            disabled={disabled}
            required={false}
            removebackgroundColor={true}
            value={leadOtherDetails?.date}
            maxDate={moment().toDate()}
            onChange={(date) => {
              setLeadOtherDetails({
                ...leadOtherDetails,
                date: date,
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-4">
          <DatePicker
            label="Timeframe of purchase"
            disabled={disabled}
            required={true}
            value={leadOtherDetails?.timeframeOfPurchase}
            minDate={moment().toDate()}
            onChange={(date) => {
              setLeadOtherDetails({
                ...leadOtherDetails,
                timeframeOfPurchase: date,
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-4">
          <div className="d-flex flex-column">
            <Label
              className="mb-2"
              style={{
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'rgba(0, 0, 0, 0.6)',
              }}
            >
              Ever Insured
            </Label>

            <RadioGroup
              row
              name="everInsured"
              value={leadOtherDetails?.everInsured ?? ''}
              onChange={(e) => {
                setLeadOtherDetails({
                  ...leadOtherDetails,
                  everInsured: e.target.value,
                });
              }}
            >
              <FormControlLabel
                value="yes"
                control={<Radio size="small" />}
                disabled={disabled}
                label="Yes"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.8rem',
                  },
                }}
              />

              <FormControlLabel
                value="no"
                control={<Radio size="small" />}
                disabled={disabled}
                label="No"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.8rem',
                  },
                }}
              />
            </RadioGroup>
          </div>
        </Col>
        <Col xs={12} md={4} className="activity-log-margin create-input">
          <div className="mb-2">
            <Label
              for="comment"
              className="mt-2"
              style={{
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'rgba(0, 0, 0, 0.6)',
              }}
            >
              Additional information
            </Label>
            <Input
              id="AdditionalInformation"
              name="AdditionalInformation"
              type="textarea"
              value={leadOtherDetails?.additionalInformation}
              maxLength={500}
              className="rounded border model-comment-area comment-input"
              onChange={(event) => {
                setLeadOtherDetails({
                  ...leadOtherDetails,
                  additionalInformation: event.target.value,
                });
              }}
              readOnly={disabled}
              style={
                disabled
                  ? {
                      color: '#999',
                    }
                  : {}
              }
            />
          </div>
        </Col>
      </Row>

      {leadOtherList.length > 0 ? (
        <Row className="mt-4">
          <Col xs={12} md={12}>
            <KTable
              data={leadOtherList}
              tableParentClass=""
              columnHeader={VIEW_LEADOTHERDETAILS_HEADER}
              isLoading={false}
              showNoDataFoundMsg={false}
              onAction={(action, rowData) => {
                if (rowData?.action === CLICK_ACTIONS.DELETE) {
                  handleRemoveOtherLead(action.id);
                }
              }}
            />
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

export default OtherSectionPage;
